import React, { createContext, useState, useEffect, ReactNode } from 'react';
import { getAllContainers, getTankTypes, getDistanceUOMs } from './services';
import { IContainer, IContainerType, ILengthUOM } from '../model';

type ContainersContextType = {
  containers: IContainer[];
  loading: boolean;
  refreshContainers: (inactive?: boolean) => Promise<void>;
  tankTypes: IContainerType[];
  distanceUOMs: ILengthUOM[];
};

export const ContainersContext = createContext<ContainersContextType>({
  containers: [],
  loading: false,
  refreshContainers: async () => {},
  tankTypes: [],
  distanceUOMs: [],
});

export const ContainersProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [containers, setContainers] = useState<IContainer[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [tankTypes, setTankTypes] = useState<IContainerType[]>([]);
  const [distanceUOMs, setDistanceUOMs] = useState<ILengthUOM[]>([]);

  const refreshContainers = async (inactive = true) => {
    setLoading(true);
    try {
      const data = await getAllContainers(inactive);
      setContainers(data);
    } catch (error) {
      console.error('Error loading containers:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshContainers();
    getTankTypes().then((data) => setTankTypes(data));
    getDistanceUOMs().then((data) => setDistanceUOMs(data));
  }, []);

  return (
    <ContainersContext.Provider value={{ containers, loading, refreshContainers, tankTypes, distanceUOMs }}>
      {children}
    </ContainersContext.Provider>
  );
};
